import {yupResolver} from '@hookform/resolvers/yup'
import {ChangeEvent, Dispatch, FC, SetStateAction, useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {AttendClaimDocument, AttendClaimModel} from '../../../../model/claim.model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {InputDate, InputText, InputTextArea} from '../../../../../../components/UI/Input'
import {UserModel} from '../../../../model'
import {getMasterService, getUser} from '../../../../services'
import moment from 'moment'
import {SelectModel} from '../../../../../lavanderia/model'
import {
  createClaimAttentionService,
  getClaimById,
  updateClaimAttentionService,
  downloadClaimDocumentsAttentionService,
  downloadClaimDocumentsAttentionServiceV,
} from '../../../../services/claim.service'
import {formatDate} from '../../../../../../util/dates'
import {TabCentralModel} from '../../../../../../models'
import {ShowSnackBar} from '../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  claimToEdit: AttendClaimDocument
  getAttentionList: () => void
  created: boolean
}

const ModalAttendClaim: FC<Props> = ({show, setShow, claimToEdit, getAttentionList, created}) => {
  const handleClose = () => {
    setShow(false)
    resetForm()
  }
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [users, setUsers] = useState<any[]>([])
  const [requerimentTypes, setRequerimentTypes] = useState<SelectModel[]>([])
  const [file, setFile] = useState<File | null>(null)
  const [error, setErrorFile] = useState('')
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const attendSchema = Yup.object().shape({
    ResponsableId: Yup.string().required('Responsable es requerido'),
    FechaAtencion: Yup.string().required('Fecha de Atencion es requerido'),
    Atencion: Yup.string().required('Atencion es requerido'),
  })
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setErrorFile('')
  }

  const methods = useForm<AttendClaimModel>({
    resolver: yupResolver(attendSchema),
  })

  const {
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    control,
    formState: {errors},
  } = methods
  const getUsers = async (filters: UserModel, page: number) => {
    try {
      const response = await getUser(filters, 1)
      const data = response.data.data
      const mappedUsers = data?.map((user) => ({
        value: user.id,
        label: `${user.nombres || ''} ${user.apellidos || ''} ${user.numeroDocumento || ''}`,
        ...user,
      }))
      setUsers(mappedUsers)
    } catch (error) {
      return []
    }
  }

  const getRequerimentTypes = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setRequerimentTypes(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de requerimientos:', error)
    }
  }

  const getClaimId = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getClaimById(idToEdit as any)
        const {TipoRequerimientoId} = data
        setValue('TipoRequerimientoId', TipoRequerimientoId)
      }
    } catch (error) {}
  }

  const handleSetUserInfo = async (val: any) => {
    let value = val ? val.value : ''
    setValue('ResponsableId', value)
    setError('ResponsableId', {})
    setValue('Cargo_Responsable', val.cargo)
    setValue('Empresa_Responsable', val.empresa)
    setValue('Telefono_Responsable', val.telefono)
    setValue('Email_Responsable', val.email)
  }

  const resetForm = () => {
    setValue('ResponsableId', '')
    setValue('Cargo_Responsable', '')
    setValue('Empresa_Responsable', '')
    setValue('Telefono_Responsable', '')
    setValue('Email_Responsable', '')
    setValue('FechaAtencion', '')
    setValue('Atencion', '')
    setValue('UrlDocumento', '')
  }

  useEffect(() => {
    getUsers({isCombo: true}, 1)
    setValue('RequerimientoId', currentTabItem.idToEdit as any)
    // setValue('ReservaId', currentTabItem.idToEdit as any)
  }, [])

  useEffect(() => {
    if (!created) {
      setValue('Id', claimToEdit?.Id)
      setValue('ResponsableId', claimToEdit?.ResponsableId)
      setValue('Cargo_Responsable', claimToEdit?.Responsable_cargo)
      setValue('Empresa_Responsable', claimToEdit?.Responsable_empresa)
      setValue('Telefono_Responsable', claimToEdit?.Responsable_telefono)
      setValue('Email_Responsable', claimToEdit?.Responsable_email)
      setValue('FechaAtencion', formatDate(claimToEdit?.FechaAtencion))
      setValue('Atencion', claimToEdit?.Atencion)
      setValue('UrlDocumento', claimToEdit?.UrlDocumento)
    }
  }, [created])

  useEffect(() => {
    getUsers({isCombo: true}, 1)
    getRequerimentTypes()
    getClaimId()
    setValue('RequerimientoId', currentTabItem.idToEdit as any)
  }, [])

  const onSubmit = async (data: any) => {
    try {
      const obj: TabCentralModel = {
        ...currentTabItem,
        loadingTable: false,
      }
      changeCurrentTabItem(obj)
      const formData = new FormData()
      if (file) {
        formData.append('File', file)
      }
      if (data.Id) {
        formData.append('Id', data.Id)
      }
      formData.append('ResponsableId', data.ResponsableId)
      formData.append('FechaAtencion', data.FechaAtencion)
      formData.append('Atencion', data.Atencion)
      formData.append('RequerimientoId', currentTabItem.idToEdit as any)
      const {data: res} = created
        ? await createClaimAttentionService(formData)
        : await updateClaimAttentionService(formData)
      if (!res.error) {
        ShowSnackBar(`Se ${created ? 'creó' : 'actualizó'} con éxito`)
        handleClose()
        getAttentionList()
        const obj2: TabCentralModel = {
          ...currentTabItem,
          loadingTable: true,
        }
        changeCurrentTabItem(obj2)
        // mostrar snackbar
      } else {
        ShowSnackBar(res.message || 'Hubo un error', 'error')
      }
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  const handleDownload = async () => {
    try {
      const response = await downloadClaimDocumentsAttentionServiceV(claimToEdit.Id)
      const contentType = response.headers['content-type'] || 'application/octet-stream'
      const blob = new Blob([response.data], {type: contentType})

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${claimToEdit.NombreDocumento}` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{created ? 'Crear' : 'Editar'} Respuesta</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='p-6'>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Tipo de Requerimiento:</label>
                    <Select
                      control={control}
                      name='TipoRequerimientoId'
                      data={requerimentTypes}
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Datos del responsable que atiende</label>
                    <Select
                      control={control}
                      name='ResponsableId'
                      data={users}
                      errors={errors}
                      onChangeValue={handleSetUserInfo}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Cargo del responsable de atención:</label>
                    <InputText
                      register={register}
                      name='Cargo_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Empresa del responsable de atención:</label>
                    <InputText
                      register={register}
                      name='Empresa_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Teléfono del responsable de atención:</label>
                    <InputText
                      register={register}
                      name='Telefono_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Email del responsable de atención:</label>
                    <InputText
                      register={register}
                      name='Email_Responsable'
                      errors={errors}
                      disabled
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Fecha de atención:</label>
                    <InputDate
                      name='FechaAtencion'
                      register={register}
                      errors={errors}
                      minValue='1900-01-01'
                      defaultValue={moment().format('YYYY-MM-DD')}
                    />
                  </div>
                  <div className='col-sm-12 col-md-6 col-lg-3'>
                    <label className='form-label'>Examinar</label>
                    <div className='input-group input-group-sm'>
                      <input
                        className='form-control'
                        type='file'
                        id='formFileRoom'
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />
                    </div>

                    {error && <p className='error-message'>{error?.toString()}</p>}
                    {watch('UrlDocumento') && (
                      <div
                        onClick={handleDownload}
                        style={{
                          fontSize: '12px',
                          color: 'blue',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                      >
                        Descarga el documento actual
                      </div>
                    )}
                  </div>
                  <div className='col-sm-12 col-lg-9'>
                    <label className='required'>Respuesta y/o comentario de atención:</label>
                    <InputTextArea register={register} name='Atencion' errors={errors} />
                  </div>
                </div>
                {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAttendClaim}
